export default __webpack_public_path__ + "static/media/image.4646afcf.svg";